<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-2 py-lg-2 pt-lg-2">
      <div class="container">
        <div class="header-body text-center mb-6">
        </div>
      </div>
    </div>

    <div class="container mt-4 mb-6">
      <div class="row">
        <div class="col-3">
          <InfoMenu/>
        </div>
        <div class="col-9">
          <h2>Документация по API</h2>
          <p>Скоро...</p>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import InfoMenu from './Menu'
  export default {
    name: 'InfoAPI',
    components: { InfoMenu }
  }
</script>
<style></style>
